import React from 'react'
import PropTypes from 'prop-types'
import IconCheck from '../../../img/icon-check.svg'
import IconCloseCircle from '../../../img/icon-close-circle.svg'
import IconQuestion from '../../../img/icon-question.svg'
import SVGWrapper from '../SVGWrapper'

const RequirementDetail = ({ requirement, type, indent = 0 }) => {
    let isRequirementMet = 'false'
    let statusIcon = (
        <SVGWrapper title="An X icon">
            <IconCloseCircle />
        </SVGWrapper>
    )

    if (requirement.isMet === true) {
        isRequirementMet = 'true'
        statusIcon = (
            <SVGWrapper title="A check mark icon">
                <IconCheck />
            </SVGWrapper>
        )
    } else if (requirement.isMet === 'maybe') {
        isRequirementMet = 'maybe'
        statusIcon = (
            <SVGWrapper title="A question mark icon">
                <IconQuestion />
            </SVGWrapper>
        )
    }

    return (
        <>
            <div className={`requirement ${indent ? `is-indented-${indent}` : ''}`}>
                <h6 className="title is-6 is-normal">
                    {type === 'project' && <div className="status blank" />}
                    {type === 'spatial' && (
                        <div className={`status ${isRequirementMet}`}>
                            <span className="svg-icon icon-24">{statusIcon}</span>
                        </div>
                    )}
                    {requirement.label}
                </h6>
                <div className="description">{requirement.description}</div>
            </div>

            {requirement.show &&
                (requirement.requirements || []).map(req => (
                    <React.Fragment key={req.label.split(' ').join('')}>
                        <RequirementDetail type={type} requirement={req} indent={indent + 1} />
                    </React.Fragment>
                ))}
        </>
    )
}

RequirementDetail.propTypes = {
    requirement: PropTypes.shape({
        label: PropTypes.string.isRequired,
        description: PropTypes.element.isRequired,
        requirements: PropTypes.array
    }).isRequired,
    type: PropTypes.string.isRequired,
    indent: PropTypes.number
}

export default RequirementDetail
